export default __webpack_public_path__ + "static/media/darkLocation.143da7c4.svg";